import { Box, CircularProgress, Tooltip } from "@mui/material";
import { moneyFormat } from "../../../Utils";

export function MetricContainer({ children, borderColor }) {
    return <Box sx={{
        height: '100%', width: '100%',
        border: `1px solid ${borderColor}`,
        borderRadius: '16px',
        minHeight: '180px',
        padding: 1,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'normal',
        textAlign: 'center',
        position: 'relative'
    }}>
        {children}
    </Box>
}

export function MetricTopRight({ children }) {
    return (<Box sx={{
        position: 'absolute',
        top: 2,
        right: 5,
        opacity: 0.5, // make the text less prominent
        maxWidth: '45%',
        textWrap: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    }}>
        <span style={{ fontSize: '1rem' }}>{children}</span>
    </Box>)
}

export function MetricTopLeft({ children }) {
    return (<Box sx={{
        position: 'absolute',
        top: 2,
        left: 5,
        opacity: 0.5, // make the text less prominent
        maxWidth: '45%',
        textWrap: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    }}>
        <span style={{ fontSize: '1rem' }}>{children}</span>
    </Box>)
}

export function MetricLoading({ isLoading }) {
    return (isLoading && <Box
        sx={{
            justifyContent: 'center',
            alignItems: 'normal',
            width: '100%',
            flexGrow: 1,
        }}>
        < CircularProgress sx={{ display: 'block', margin: 'auto' }} />
    </Box>)
}

function displayInfinitySign(num) {
    if (num === Infinity) {
        return '∞';
    } else if (num === -Infinity) {
        return '−∞';
    } else if (isNaN(num)) {
        return '-';
    } else {
        return moneyFormat(num);
    }
}

export function MetricSingleValue({ value, valueFormatter, comparisonValue, tooltip }) {
    if (value === undefined || value === null) {
        return <Box sx={{ width: '100%', flexGrow: 1 }} />
    }
    let percentageChange = null;
    if (comparisonValue !== undefined && comparisonValue !== null) {
        if (comparisonValue === 0) {
            percentageChange = value === 0 ? 0 : Infinity;
        } else {
            percentageChange = ((value - comparisonValue) / comparisonValue) * 100
        }
    }
    return (
        <Box
            sx={{
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'center',
                width: '100%',
                flexGrow: 1,
                fontSize: '2.5rem',
            }}>
            <Tooltip title={tooltip ?? ''}>
                <span>{Boolean(valueFormatter) ? valueFormatter(value) : value}</span>
            </Tooltip>
            {percentageChange !== null &&
                <Box
                    sx={{
                        fontSize: '1rem',
                        fontWeight: 'bold',
                        color: percentageChange >= 0 ? 'success.main' : 'error.main',
                    }}>
                    <Tooltip title={`Vs. last period`} enterDelay={500} enterNextDelay={500}>
                        <span>{`${percentageChange >= 0 ? '+' : ''}${displayInfinitySign(percentageChange)}%`}</span>
                    </Tooltip>
                </Box>
            }
        </Box>
    )
}